import useQuizTopics from 'hooks/API/GET/useQuizTopics';
import useManageQuiz from 'hooks/API/useManageQuiz';
import useToaster from 'hooks/useToaster';
import { useParams } from 'react-router-dom';
import QuizHandleSection from './QuizHandleSection';

function ManageQuiz() {
  const { isLoading, mutate, isError } = useManageQuiz();
  const { quizID, topicID } = useParams();

  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  const { data } = useQuizTopics({
    enabled: !!(quizID && topicID),
    quizID,
    topicID,
  });

  function handleQuiz(quizFormData = {}) {
    if (isLoading) return;

    if (data?.data?._id) {
      quizFormData.id = data?.data?._id;
    }

    mutate(quizFormData);
  }

  return (
    <div className="mainWraper">
      <div className="container">
        <QuizHandleSection handleQuiz={handleQuiz} preloadedData={data?.data ?? {}} />
      </div>
    </div>
  );
}

export default ManageQuiz;
